var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNot = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.61 12.39a1.68 1.68 0 0 1-.43 1.13A1.51 1.51 0 0 1 7 14a1.51 1.51 0 0 1-1.18-.48 1.7 1.7 0 0 1 0-2.26A1.51 1.51 0 0 1 7 10.78a1.51 1.51 0 0 1 1.18.48 1.68 1.68 0 0 1 .43 1.13ZM8 9.55H6L5.6 0h2.8Z"
})));
export default SvgNot;